module.exports = __webpack_public_path__ + "img/lognBgW.98a8ea93.png";